/**
 * @desc: - 分页
 * @param  {[string]} className   [顶层class]
 * @param  {[number]} current     [当前页码]
 * @param  {[number]} allData     [全部数据]
 * @param  {[number]} onePageDate [一页数据条数]
 * @param  {[array]}  pagenum     [所有页码]
 * @author: circle
 */

import React from 'react';

export default class Page extends React.Component {
	constructor(props){
		super(props)
        
	}

    //获取总页数  当前标签下的总数据/一页展示的数据量
    getPageNum(){
        let totalPage = this.props.allData/this.props.onePageDate
        totalPage = Math.ceil(totalPage)
        let pageNum = new Array()
        for(let i = 1; i<totalPage+1; i++){
            pageNum.push(i)
        }
        return pageNum;
    }
    //去首页
    goIndex(){
        let {changeCurrentPage,current} = this.props
        changeCurrentPage(1)
    }

    //去尾页
    goLast(){
        let {changeCurrentPage,current} = this.props
        changeCurrentPage(Math.ceil(this.props.allData/this.props.onePageDate))
    }

    //下一页
    goNext(){
        let {changeCurrentPage,current} = this.props
        if(current ==  Math.ceil(this.props.allData/this.props.onePageDate)){
            return;
        }else{
            changeCurrentPage(current + 1)
        }
    }
    
    //上一页
    goPrev(){
        let {changeCurrentPage,current} = this.props
        if(current == 1){
            return;
        }else{
            changeCurrentPage(current - 1)
        }
    }

	render(){
        let {className,current,changeCurrentPage} = this.props
        className = className || "pt-paging"
        const totlePageNo = this.getPageNum();
        let pageNum = totlePageNo.map((key,index)=>{
            return(
                <a key={index} className={key==current?'active pointer': 'pointer'} onClick={()=>{changeCurrentPage(key)}}>{key}</a>
            )
        })
		return (
            <div className={className}>
                <a className={current == 1?"first onone":"first"} onClick ={this.goIndex.bind(this)}>首页</a>
                <a className={current ==  1?"prev onone":"prev"} onClick = {this.goPrev.bind(this)}>上页</a>
                {pageNum}
                <a className={current ==  Math.ceil(this.props.allData/this.props.onePageDate)?"next onone":"next"} onClick = {this.goNext.bind(this)}>下页</a>
                <a className={current ==  Math.ceil(this.props.allData/this.props.onePageDate)?"last onone":"last"} onClick = {this.goLast.bind(this)}>尾页</a>
                <span>共{current + "/" + Math.ceil(this.props.allData/this.props.onePageDate)}页</span>
            </div>
		)

	}
}